module.exports = __webpack_public_path__ + "img/license.c9a19204.svg";